import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastProvider } from "./context/ToastContext";
import "./index.css";

// Components
import Layout from "./components/Layout";
import AuthGuard from "./components/AuthGuard";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Websites from "./pages/Websites";
import WebPages from "./pages/web-pages";
import CourseProgramsRoutes from "./pages/course-programs";
import Menus from "./pages/Menus";
import NewsNotices from "./pages/NewsNotices";
import Downloads from "./pages/Downloads";
import Sliders from "./pages/Sliders";
import Popups from "./pages/Popups";
import Testimonials from "./pages/Testimonials";
import Gallery from "./pages/Gallery";
import ContentLists from "./pages/ContentLists";
import Forms from "./pages/Forms";
import FreeNotes from "./pages/FreeNotes";
import QuillEditor from "./pages/quill";

// Store
import useAuthStore from "./store/authStore";
import QSet from "./pages/qSet-pages/index";
import CompareQSet from "./pages/qSet-pages/compare";
import Layout2 from "./components/Layout2";
import Task from "./pages/task";
import OldQSet from "./pages/QSet";
const App = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route
              path="/login"
              element={
                !isAuthenticated ? <Login /> : <Navigate to="/tools/qSet" />
              }
            />

            {/* Protected routes */}
            <Route element={<AuthGuard />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/websites" element={<Websites />} />
                <Route path="/web-pages/*" element={<WebPages />} />
                <Route
                  path="/course-programs/*"
                  element={<CourseProgramsRoutes />}
                />
                <Route path="/menus" element={<Menus />} />
                <Route path="/news-notices" element={<NewsNotices />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/sliders" element={<Sliders />} />
                <Route path="/popups" element={<Popups />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/content-lists" element={<ContentLists />} />
                <Route path="/forms" element={<Forms />} />
                <Route path="/free-notes" element={<FreeNotes />} />
                <Route path="/quill" element={<QuillEditor />} />
                <Route path="/tools/qSet/*" element={<QSet />} />
                <Route path="/tools/task/*" element={<Task />} />

                {/* <Route path="/tools/old-qset" element={<OldQSet />} /> */}
              </Route>

              {/* <Route element={<Layout2/>}> */}
              <Route path="/tools/qSet/compare/:id" element={<CompareQSet />} />
              {/* </Route> */}
            </Route>

            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/tools/qSet" />} />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
};

export default App;
